import { useRef, useState } from "react";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/shared/ui/Tooltip";
import type { TruncateWrapperProps } from "../types";

export const TruncateWrapper = ({
  children,
  enableTooltip = true,
  tooltipClassName,
}: TruncateWrapperProps) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const handleMouseEnter = () => {
    if (!enableTooltip || !textRef.current) return;

    const element = textRef.current;

    // Check if the wrapper itself is truncated
    const isWrapperTruncated = element.scrollWidth > element.offsetWidth;

    // Also check if any nested elements with 'truncate' class are truncated
    const truncatedChildren = element.querySelectorAll(".truncate");
    const hasAnyTruncatedChild = Array.from(truncatedChildren).some(
      (child) => child.scrollWidth > child.clientWidth,
    );

    setIsTruncated(isWrapperTruncated || hasAnyTruncatedChild);
  };

  const content = (
    <div
      ref={textRef}
      className="truncate w-full cursor-pointer"
      onMouseEnter={handleMouseEnter}
    >
      {children}
    </div>
  );

  if (!enableTooltip) {
    return content;
  }

  // Conditionally render the entire Tooltip wrapper to avoid Radix UI ref update loops
  return isTruncated
    ? (
      <Tooltip>
        <TooltipTrigger asChild>{content}</TooltipTrigger>
        <TooltipContent className={tooltipClassName}>{children}</TooltipContent>
      </Tooltip>
    )
    : (
      content
    );
};
